import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { FormLabel } from '../FormLabel';
import { FormHelperText } from '../FormHelperText';
import { pickComponentCommonProps } from '../../interfaces/commonProps';
import { useSpacing } from '../../api/spacing/useSpacing';
import { StyledIcon, StyledContainer, StyledSelect, StyledSelectContainer } from './Select.styles';

var noop = function noop() {};

export var Select = React.forwardRef(function (_ref, ref) {
  var autoComplete = _ref.autoComplete,
      children = _ref.children,
      defaultValue = _ref.defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      hint = _ref.hint,
      id = _ref.id,
      inputId = _ref.inputId,
      inputRef = _ref.inputRef,
      label = _ref.label,
      name = _ref.name,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      value = _ref.value,
      validationMessage = _ref.validationMessage,
      restProps = _objectWithoutProperties(_ref, ["autoComplete", "children", "defaultValue", "disabled", "invalid", "hint", "id", "inputId", "inputRef", "label", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "value", "validationMessage"]);

  var hintMessageId = "".concat(inputId, "__hint-message");
  var validationMessageId = "".concat(inputId, "__error-message");
  var describedBy = [hint ? hintMessageId : '', invalid ? validationMessageId : ''].join(' ').trim() || undefined;
  var empty = !value;
  var defaultOptionProps = {
    'aria-hidden': required,
    disabled: required,
    value: ''
  };
  return React.createElement(StyledContainer, _objectSpread({
    id: id,
    outerSpacing: useSpacing(restProps),
    ref: ref
  }, pickComponentCommonProps(restProps)), React.createElement(FormLabel, {
    disabled: disabled || readOnly,
    variant: "float",
    empty: empty,
    invalid: invalid,
    htmlFor: inputId,
    required: required
  }, label), React.createElement(StyledSelectContainer, {
    disabled: disabled,
    invalid: invalid,
    readOnly: readOnly
  }, !readOnly && React.createElement(StyledIcon, {
    disabled: disabled,
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M7 10L12.5 15.5 18 10",
    stroke: "currentColor",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  })), React.createElement(StyledSelect, {
    autoComplete: autoComplete,
    "aria-describedby": describedBy,
    disabled: disabled || readOnly,
    empty: empty,
    invalid: invalid,
    id: inputId,
    name: name,
    value: value,
    defaultValue: defaultValue,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    readOnly: readOnly,
    ref: inputRef,
    required: required
  }, React.createElement("option", _objectSpread({}, defaultOptionProps), label), children)), hint && React.createElement(FormHelperText, {
    id: hintMessageId,
    spaceStackStart: 's',
    variant: "hint"
  }, hint), invalid && React.createElement(FormHelperText, {
    id: validationMessageId,
    spaceStackStart: hint ? 'xxs' : 's',
    variant: "invalid"
  }, validationMessage));
});
Select.displayName = 'Select';